
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("6rCd1", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.d0dee413.js.map
